import { BELGE_TURU_VE_DURUMUNA_GORE_RESMI_BASVURU_LISTESI } from "../constants/requestUrls";
import { postRequest } from "../request";

const belgeTuruVeDurumunaGoreResmiBasvuruListesi = (BelgeGrubuId,belgeTuruId, BasvuruAnaDurumId) => {
  
    var BelgeTuruId = [];
    BelgeTuruId.push(belgeTuruId);
    let data = {BelgeTuruId, BasvuruAnaDurumId,BelgeGrubuId};
    data =JSON.stringify(data);
  
    return postRequest({url:BELGE_TURU_VE_DURUMUNA_GORE_RESMI_BASVURU_LISTESI,data});
}

export default belgeTuruVeDurumunaGoreResmiBasvuruListesi;